import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';
import MYStateJSON from 'src/assets/data/einvoice-my-state.json';

@Component({
  selector: 'app-einvoice-my-state-select',
  templateUrl: './einvoice-my-state-select.component.html',
  styleUrls: ['./einvoice-my-state-select.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    ViewItemComponent
  ],
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceMYStateSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceMYStateSelectComponent implements ControlValueAccessor {
  options = [...MYStateJSON];
  nzFilterOption = (): boolean => true;

  @Input() value: string = '';
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() isRequired = false;
  @Input() selectNotApplicableOnly = false;
  @Input() hideNotApplicable = false;
  @Input() fieldName: 'name' | 'code' = 'name';

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.name === this.value);
    if (item) return `${item.name}`;
    return '';
  }

  get availOptions() {
    let result = [...this.options];

    if (this.selectNotApplicableOnly) {
      result = result.filter(o => o.code === '17');
      return result;
    }

    if (this.hideNotApplicable) {
      result = result.filter(o => o.code !== '17');
    }

    return result;
  }

  filteredOptions = [...this.availOptions]; // Initialize with all options
  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onSearch(searchText: string): void {
    const search = searchText.trim().toLowerCase();
    this.filteredOptions = this.availOptions.filter((item) => 
      item.name.toLowerCase().includes(search) || 
      item.code.toLowerCase().includes(search)
    );
    this.cdr.detectChanges(); // Ensure the UI updates
  }

  refreshOptions(country: string) {
    if(country === 'MY') {
      this.selectNotApplicableOnly = false;
      this.hideNotApplicable = true;
    }
    else {
      this.selectNotApplicableOnly = true;
      this.hideNotApplicable = false;
    }

    this.filteredOptions = [...this.availOptions];

    // Force change detection
    this.cdr.detectChanges();
  }
}
